export const footer = {
  copyright: "Copyright",
  faq: "FAQ",
  contact_us: "Contact Us",
  tos: "Terms of Use",
  video_policy: "Video Policy",
  privacy_policy: "Privacy Policy",
  back_to_top: "BACK TO TOP",
};
